module.exports = __webpack_public_path__ + "static/img/zhutu铣刨机.d98f4d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/zhutu铣刨机.png
// module id = V1R5
// module chunks = 0